/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { FormGroup, FormText, Input, Label } from 'reactstrap';
import { isMessageValid, MESSAGE_MAX_LENGTH } from '../utils';

interface MessageFieldProps {
  onChange: (message: string) => void;
  message?: string;
}

export const MessageField = (props: MessageFieldProps) => {
  const { message, onChange } = props;

  return (
    <FormGroup>
      <Label for='subject'>
        Message
      </Label>
      <Input
        type='textarea'
        placeholder='Enter your message here...'
        maxLength={MESSAGE_MAX_LENGTH}
        valid={isMessageValid(message)}
        value={message}
        onChange={e => onChange(e.target.value)}
        rows={5}
      />
      <FormText className='text-right'>
        {`${message?.length ?? 0}/${MESSAGE_MAX_LENGTH}`}
      </FormText>
    </FormGroup>
  );
}
